
import React from 'react';

// import { ModelBase, PlayerObject } from '../../../../models';

import FSIndex from "@dndComponents/FSIndex";
// import DandDAPI from '../../utilities/system_api';
// import { EldritchInvocation } from '../../models';

// const api = DandDAPI.getInstance();

export default function EldritchInvocationIndex() {
  return (
    <FSIndex
      data_type="eldritch_invocation"
      // extra_filter={(obj: ModelBase | PlayerObject) => {
      //   if (obj instanceof ModelBase) {
      //     const variants = (api.smart_hash.eldritch_invocation).filter(o => o.variant_group_id === obj.variant_group_id);
      //     if (variants.filter(o => o.source_book_ids.includes("6675b302a4476741138fa22b")).length === 0) {
      //       return !obj.is_archived;
      //     }
      //   }
      //   return false;
      // }}
    />
  );
}
